export const flattenAndConvertToArray = (object: object) => (
    Object.values(object).flat(Infinity)
)